import { useMediaQuery } from '@vueuse/core';
import { ref } from 'vue-demi';

function useResponsive() {
  const isMobile = ref(useMediaQuery('(max-width: 767px)'));
  const isDesktop = ref(useMediaQuery('(min-width: 768px)'));
  return {
    isMobile,
    isDesktop
  };
}

export { useResponsive as u };
